module.exports = __webpack_public_path__ + "img/3-top.747a86fd.png";